import { BaixaCobranca } from './../../../model/baixa-cobranca.model';
import { TarefasCobrancaService } from './tarefas-cobranca.service';
import { Component, OnInit } from "@angular/core";
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';


@Component({
    selector: 'app-tarefas-cobranca',
    templateUrl: './tarefas-cobranca.component.html',
    styleUrls: ['./tarefas-cobranca.component.scss'],
    standalone: false
})
export class TarefasCobrancaComponent implements OnInit {

  public emailsEnvioPlanilha: string;
  public emailsEnvioContabilizacoes: string;
  public baixaCobranca: BaixaCobranca;
  public ideCobranca: number;
  public dataSimulacaoPagamento: Date;
  public valorSimulacaoPagamento: number;
  public baixarPeloValorIntegral: boolean = true;
  public idSistema: number = 84;
  public prefixoVsam: string;
  public ibm: boolean;
  public local: boolean;
  private anexoVsam: string;
  private nomeAnexoVsam: string;

  constructor(
    private cobrancaService: TarefasCobrancaService,
    private messageService: MessageChannelService,
    private alertService: BnAlertsService,
    private loadingService: BnLoadingService,
    private fileUtils: FileUtilsService,) {
  }

  ngOnInit(): void {

  }

  public emite() {
    this.loadingService.bloqueiaTela();
      this.cobrancaService.emitir().subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Cobrança emitida com sucesso.'
        })
        this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public baixa() {
    let dto: any = {};
    if(this.ideCobranca) {
      dto.ideCobranca = this.ideCobranca;
    }
    if(this.dataSimulacaoPagamento) {
      dto.dataSimulacaoPagamento = moment(this.dataSimulacaoPagamento).format('YYYY-MM-DD');
    }
    if(this.valorSimulacaoPagamento) {
      dto.valorSimulacaoPagamento = this.valorSimulacaoPagamento;
    }
    if(this.baixarPeloValorIntegral) {
      dto.baixarPeloValorIntegral = this.baixarPeloValorIntegral;
    }
    this.loadingService.bloqueiaTela();
    this.cobrancaService.baixar(dto).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Cobrança baixada com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public simularEmissao() {
    this.loadingService.bloqueiaTela();
      this.cobrancaService.simularEmissao().subscribe((msgRetorno: RetornoMensagemSimplesDTO) => {
        this.messageService.addMessage({
          title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: `${msgRetorno.mensagem}`
        })
        this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public simularBaixa() {
    this.loadingService.bloqueiaTela();
      this.cobrancaService.simularBaixa(this.ideCobranca).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Simulação da baixa realizada com sucesso.'
        })
        this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public geraPlanilhaSCC() {
    const listaEmailPlanilha = this.emailsEnvioPlanilha.split(";")
    this.loadingService.bloqueiaTela();
      this.cobrancaService.gerarPlanilhaSCC(listaEmailPlanilha)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
              type: 'CRUD_OPERATION',
              level: messageLevel.SUCCESS,
              message: 'Planilha SCC gerada com sucesso.'
            })
          this.loadingService.liberaTela();
        })
        console.log(listaEmailPlanilha);
  }

  public geraContabilizacoes() {
    const listaEmailContabilizacoes = this.emailsEnvioContabilizacoes.split(";")
    this.loadingService.bloqueiaTela();
    this.cobrancaService.gerarContabilizacoes(listaEmailContabilizacoes)
      .subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Contabilizações geradas com sucesso.'
          })
        this.loadingService.liberaTela();
        })
        console.log(listaEmailContabilizacoes);
  }

  public sincronizarVsamRcc() {
    if (
      this.idSistema == null ||
      !(this.ibm && this.prefixoVsam)
    ) {
      this.alertService.alertaErro(
        "Erro",
        "Preencha todos os campos corretamente para realizar a operação."
      );
    } else {
      this.loadingService.bloqueiaTela();
      this.cobrancaService
        .sincronizarVsamRcc(
          this.idSistema,
          this.prefixoVsam
        )
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Sincronização realizada com sucesso.",
          });
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
        console.log("idSistema: "+this.idSistema)
        console.log("prefixoVsam: "+this.prefixoVsam)
    }
   
  }
  public sincronizarVsamRccComArquivoEnviadoPeloPortal() {
    if (
      this.idSistema == null ||
      !( this.local && this.anexoVsam)
    ) {
      this.alertService.alertaErro(
        "Erro",
        "Preencha todos os campos corretamente para realizar a operação."
      );
    } else {
      this.loadingService.bloqueiaTela();
      this.cobrancaService
        .sincronizarVsamRccComArquivoEnviadoPeloPortal(
          this.idSistema,
          this.anexoVsam
        )
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Sincronização realizada com sucesso.",
          });
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
    }
   
  }
  onFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          this.anexoVsam = reader.result;
        } else {
          this.anexoVsam = this.fileUtils.lerConteudo(reader);
        }

        console.log("Conteúdo do upload .vsm:  " + this.anexoVsam);
        this.nomeAnexoVsam = file.name;
      };
    }
  }

  onLocalizacaoChange(event){
    this.prefixoVsam=null;
    this.anexoVsam=null;
    this.nomeAnexoVsam=null;
  }

  public limparBaixarCobranca(){
    this.ideCobranca = null;
    this.dataSimulacaoPagamento = null;
    this.valorSimulacaoPagamento = null;
    this.baixarPeloValorIntegral = null;
  }
  public limparGerarPlanilha(){
    this.emailsEnvioPlanilha = null;
  
  }
  public limparGerarContabilizacoes(){
    this.emailsEnvioContabilizacoes = null;
  }
  public limparSincronizarVsamRcc(){
    this.idSistema = null;
    this.ibm = null;
    this.local = null;
    this.prefixoVsam = null;
    this.anexoVsam=null;
    this.nomeAnexoVsam=null;
  }

}
